/*
	tcr.subscription.js - Ajax and utility functions for Subscriptions
    This requires the following global variables to be initialised

    TCR.subscriptions - a list of all the subscriptions for the current customer
    Changes:
    1 August -2014 - Created
    25 August - Added Method, milk, Price etc
    30 August - Added support for Subscription sign-up
    31 August - added Price Array and redirect to Success Message after submit
    4 Sept - updated prices (8.50,15,21,23) & launched
    6 Sept - added Voucher
    16 Sept - added Roasted/Green options
    9 Oct - re-ordered options for email
    17 Oct - added subscription plans
    27 Oct - Added price per cup
    23 Nov - Added 250, 500, 1000 plans
    6 Jan 2015 - changed to use IFFE pattern
    20 May - put up prices: 750g £23, 1000g £25
    23 July - Added LTK.logHide()
    22 Sept - Added cancelled & stopped to status
    3 Jan 2016 - Added 2 x 250g option
    19 Jan - 1.2, 1.3 - Added Credit Card payment button & support for multi-country.
    	Refactored events. Removed plans
    11 Mar - Added 4 x 250g
    19 March - added :every_week_skip_3rd_week
    26 April - added 2 x 500g
    15 June - added 3 x 250g
    22 June - Added message for promo-code
    2 Aug - Added TCR-LLOYD promo code
    6 Aug - Added E-SPARK promo. Fixed contact message on one line. Now HTML
    15 Aug - Added Subscription referrals - Rui
    26 Sept - Increaded 4x price to £27
    15 Jan 2017 - Added codes I-AM-BACK & GQ-03. Added href to sub change email
    30 Jan - Updates for Gift support
    2-Feb-2017 - Setup payment buttons - changed to go directly to setup pages. No new window
    28 Feb - Fixing Sub submit and payment setup. Added code LOVE-MY-MUM
    5 April - Added MBV50 promo code
    8 April - Increased 2x price to £16
    4 May - Increased 1000g & 2x500g price to £26. Changed order of prices (but didn't work)
    21 May - Added Pay UpFront payment method
    27 June 2017 - Added 350g & 2 x 350g options
    29 Sept 2017 - Added step numbers to address legend
    3 Nov 2017 - Added every 7,8 weeks
    7 Dev 2017 - Added LINKED-IN code
    15 Dec 2017 - Added 10 weeks
    17 Feb 2018 - Removed HTML from submit message
    1.5 - 3 March 2018 - Used new Referral Code functionality. Removed old promo codes
    15 Mar 2018 - Added Stovetop
    24 April 2018 - Added 5 x 250g and removed 350g options
	20 June 2018 - Added 3 x 500 and 4 x 500g options
	31 July 2018 - Added 2 x 1000g options
	24 Sept 2018 - Added 2 x 750g options
*/
TCR.subscription = (function() {
  var MOD = "TCR.subscription.1.5.";
  function log(text) 		{ TCR.log(text); };
  //log( MOD + "JS..." );
  //LTK.logHide.push( MOD );	// Hide all these log messages

  // EXTERNAL functions
  function tcrTrack( event, eventProps ) { TCR.analytics.tcrTrack(event, eventProps); };
  function info(text) 		{ TCR.info("INFO: " + text); };
  function warning(text) 	{ TCR.warning("WARNING: " + text); };
  function error(text) 		{ TCR.error("ERROR: " + text); throw(text); };
  function message(text) 	{ log( MOD + "message() " + text ); TCR.message(text); };
  function closeMessage() 	{ log( MOD + "closeMessage()" ); TCR.closeMessage(); };
  function setReferralOffers(code)	{ TCR.offers.setReferralOffers(code); };
  function getOffer()		{ return TCR.offers.getOffer(); };
  function clearSubscriptionOffer()	{ TCR.offers.clearSubscriptionOffer(); };
  function displaySubscriptionOffer(offer)	{ TCR.offers.displaySubscriptionOffer(offer); };

  function getToken( val, index, delimiter ) 	{ return LTK.getToken( val, index, delimiter ); };
  function isBlank( obj ) 	{ return LTK.isBlank( obj ); };
  function notBlank( obj ) 	{ return LTK.notBlank( obj ); };
  function newSelectElement( options, existingValue ) { return LTK.newSelectElement( options, existingValue ); };
  function objectAttributes( obj ) 	{ return LTK.objectAttributes( obj ); };
  function getControlValue( control_id, field_type ) { return LTK.getControlValue( control_id, field_type ); };
  function getCountryZone(country) { return TCR.location.getCountryZone(country); };

  
  // Current subscriptions for the user and the default new subscription ID-0
  var CURRENT_SUBSCRIPTIONS = {
    "ID-0": {
      new: 					true,
      subscription_type:	"coffee_delivery",
      quantity:				"250g",
      frequency:			"every_4_weeks",
      method: 				"espresso",
      ground:				"no",
      milk:					"black",
      preferences:			"",
      roasted:				"roasted",
      country:				"",
      address:				"",
      postcode:				"",
      gift:					"no",
      gift_cert_posted:		"no",
      gift_cert_emailed:	"no",
      recipient_name:		"",
      recipient_email:		"",
      recipient_address:	"",
      recipient_postcode:	"",
      recipient_country:	"",
      recipient_message:	"",
      voucher:				""
    }
  };
  
  var LOCATION_PREF = TCR.preferences.location;
  var METHOD_PREF = TCR.preferences.method;
  var GRIND_PREF = TCR.preferences.grind;
  var MILK_PREF = TCR.preferences.milk;
  //	These are used to check that both location and subscription form are ready
  var LOCATION_READY = false;
  var SUB_FORM_READY = false;

  var ELEMENT = {       // DOM Elements
    form: 				"form.subscription-form",
    form_id: 			"#sub-form-",

    customer: 			"form.subscription-form input[name='contact[name]']",
    email: 				"form.subscription-form input[name='contact[email]']",
    my_address_header:	"#sub-my-address-header-",		// Header text for my address details
    my_address_form:	"#sub-my-address-form-",		// Form with my address details. Used to hide for a gift
    address:			"#sub-address-",
    postcode:			"#sub-postcode-",
    country:			"#sub-country-",
    delivery_location_message:	".delivery-location-message",

    firstname: 		".sub-firstname-",		// Used in headings & labels. Set to recipients name or 'my'
    determiner: 	".sub-determiner-",		// Used in headings & labels. 'their', 'your'
    do_does: 		".sub-do-does-",		// Used in headings & labels. 'does Lloyd', 'do you'
    tbd_text:		".sub-tbd-text-",
    
    type: 			"#sub-type-",
    price: 			"#sub-price-",
    quantity: 		"#sub-quantity-",
    frequency: 		"#sub-frequency-",
    roasted: 		"#sub-roasted-",
    status: 		"#sub-status-",
    roasted_only: 	"#sub-roasted-only-",
    ground: 		"#sub-ground-",
    ground2: 		"#sub-ground2-",
    method: 		"#sub-method-",
    method2: 		"#sub-method2-",
    milk: 			"#sub-milk-",
    milk2: 			"#sub-milk2-",
    preferences: 	"#sub-preferences-",
    
    voucher: 			"#sub-voucher-",
    voucher_message:	"#sub-voucher-message-",

    gift:				"#sub-gift-",		// Text field indicating yes or no for gift
    gift_yes:			"#sub-gift-yes",	// Gift YES Button
    gift_no:			"#sub-gift-no",		// Gift NO Button
    gift_cert_posted:	"#sub-gift-cert-posted-",
    gift_cert_emailed:	"#sub-gift-cert-emailed-",
    gift_name:				"#sub-gift-name",			// Name to get things started
    gift_name_prompt:		"#sub-gift-name-prompt",
    
    recipient_address_form:	"#sub-recipient-address-form-",		// Form with name, email, address details
    recipient_name:			"#sub-recipient-name-",
    recipient_email:		"#sub-recipient-email-",
    recipient_address:		"#sub-recipient-address-",
    recipient_postcode:		"#sub-recipient-postcode-",
    recipient_country:		"#sub-recipient-country-",
    recipient_message:		"#sub-recipient-message-",		// Personal message to recipient
    change_form: 	"#sub-",
    message: 		"#sub-message-", // The element for sending the change request
    success: 		"#sub-success-", // Where the success message will be shown
    error: 			"#sub-error-",
    hide_on_challenge:		".hide-on-challenge",		// Buttons or links to hide when challenge shown
    payment_setup:		".subscription-payment"		// Buttons or links to set up payment
  };

  var PRICES = {
    roasted: {
      "United Kingdom": {
        "250g": 	"8.50",
        "2 x 250g":	"16.00",
        "3 x 250g":	"23.00",
        "4 x 250g":	"27.00",
        "5 x 250g":	"33.00",
        
        "250g - tracked": 		"9.50",
        "2 x 250g - tracked": 	"17.00",
        "3 x 250g - tracked": 	"24.00",
        "4 x 250g - tracked":	"28.00",
        "5 x 250g - tracked":	"34.00",

        //"350g": 	"11.50",
        //"2 x 350g":	"22.00",
        
        "500g": 	"16.00",
        "2 x 500g":	"27.00",
        "3 x 500g":	"39.00",
        "4 x 500g":	"51.00",
        
        "750g": 	"23.00",
        "2 x 750g": "39.00",

        "1000g": 	"26.00",
        "2 x 1000g": "51.00"
      },
      "Europe": {
        "250g": 	"12.00",
        "2 x 250g": "21.00",
        "3 x 250g": "28.00",
        "4 x 250g":	"35.00",
        "5 x 250g":	"41.00",

        "250g - tracked": 		"16.00",
        "2 x 250g - tracked": 	"25.00",
        "3 x 250g - tracked": 	"32.00",
        "4 x 250g - tracked":	"39.00",
        "5 x 250g - tracked":	"45.00",

        //"350g": 	"16.00",
        //"2 x 350g":	"27.00",
        
        "500g": 	"21.00",
        "2 x 500g":	"35.00",
        "3 x 500g":	"47.00",
        "4 x 500g":	"59.00",
        
        "750g": 	"28.00",
        "1000g": 	"35.00"
      }
    },
    green: {
      "United Kingdom": {
        "250g": 	"7.00",
        "500g": 	"12.00",
        "2 x 250g": "20.00",
        "750g": 	"16.00",
        "1000g": 	"18.00"
      },
      "Europe": {
        "250g": 	"10.50",
        "500g": 	"17.00",
        "2 x 250g": "17.00",
        "750g": 	"20.00",
        "1000g": 	"27.00"
      }

    }
  };
  
  //	These must match Enum values in subscription.rb
  var OPTIONS = {
    type: 		["coffee_delivery", "email_recommendation"], 
    quantity: 	["250g", "2 x 250g", "3 x 250g", "4 x 250g", "5 x 250g",
                 "250g - tracked", "2 x 250g - tracked", "3 x 250g - tracked", "4 x 250g - tracked", "5 x 250g - tracked",
                 //"350g", "2 x 350g", 
                 "500g", "2 x 500g", "3 x 500g" ,"4 x 500g",
                 "750g", "2 x 750g",
                 "1000g", "2 x 1000g"],
    frequency: 	["every_week", "every_week_skip_3rd_week", "every_2_weeks", "every_3_weeks",
                 "every_4_weeks", "every_5_weeks", "every_6_weeks", "every_7_weeks", "every_8_weeks", "every_10_weeks"],
    roasted: 	["roasted", "green"],
    status: 	["active", "paused", "cancelled", "stopped"],
    ground: 	["yes", "no"],
    gift: 		["yes", "no"],
    method: 	["espresso", "stovetop", "filter", "aeropress", "cafetiere"],
    milk: 		["black", "with_milk", "milky", "mixture"]
  };

  var method="";
  var ESPRESSO_DOSE = 18;
  var FILTER_DOSE = 12;
  var GOCARDLESS = "https://dashboard.gocardless.com/api/paylinks/0NYP6ZBPAD";
  var CREDIT_CARD_SIGNUP = "//thecoffeeroasters.co.uk/pages/subscription-card-payment"
  var PAY_UPFRONT = "//thecoffeeroasters.co.uk/products/the-coffee-roasters-personalised-coffee-subscription#payment_options"
  var COUNTRY="";
  var COUNTRY_ZONE="";
  var RECIPIENT_COUNTRY="";			// Not sure if needed
  var RECIPIENT_COUNTRY_ZONE="";
  var RECIPIENT_FIRSTNAME="";		// Used for headings and labels
  var RECIPIENT_LASTNAME="";
  var VOUCHER_MESSAGE="";
  var IS_GIFT=false;

  function formError( sub_id, text ) {
    $( ELEMENT.error + sub_id ).html( text );
    $( ELEMENT.error + sub_id ).show();
  };
  function formErrorClose( sub_id ) {
    $( ELEMENT.error + sub_id ).hide();
  };

  //	Push a subscription on to the stack of current subscriptions
  
  function pushSubscription( id, subscription ) {
    var fn = MOD + "pushSubscription() ";
    log( fn + "..." + id );
    CURRENT_SUBSCRIPTIONS[ id ] = subscription;
  };
  
  //
  //	Format a subscription object to text
  //
  function toText( subscription ) {
    var text = [];

    //text.push("Name: " + subscription.customer_name);
    //text.push("Email: " + subscription.customer_email);
    if( subscription.gift ) {
      text.push("");
      if ( subscription.recipient_name != "" ) 		text.push("Recipient Name: " + subscription.recipient_name );
      if ( subscription.recipient_email != "" ) 	text.push("Recipient Email: " + subscription.recipient_email );
      if ( subscription.recipient_address != "" ) 	text.push("Recipient Address: >" + subscription.recipient_address );
      if ( subscription.recipient_postcode != "" ) 	text.push("Recipient Postcode: " + subscription.recipient_postcode );
      if ( subscription.recipient_country != "" ) 	text.push("Recipient Country: " + subscription.recipient_country );
      if ( subscription.recipient_message != "" ) 	text.push("Personal Message: " + subscription.recipient_message );
      if ( subscription.gift_cert_posted == "yes" ) 	text.push("Gift Certificate: POSTED");
      if ( subscription.gift_cert_emailed == "yes" ) 	text.push("Gift Certificate: EMAILED");
    }

    text.push("");
    if( ! subscription.new ) {
      text.push("Status: " + subscription.status.toUpperCase());
    }
    if ( subscription.subscription_type == "coffee_delivery" ) {
      // text.push("Type: Regular COFFEE DELIVERY");
      //text.push("Roasted or Green: " + subscription.roasted );
      text.push("Quantity: " + subscription.quantity );
      text.push("Frequency: " + subscription.frequency );
      text.push("Price: " + subscription.price );
    } else {
      text.push("Type: Personal EMAIL RECOMMENDATION");
      text.push("Frequency: " + subscription.frequency);
    }
    text.push("");

    if ( subscription.roasted == "roasted" ) {
      // ROASTED coffee
      text.push("Method: " + subscription.method );
      text.push("Ground: " + subscription.ground );
      text.push("Milk: " + subscription.milk );
    } else {
      // GREEN coffee
    }

    if ( subscription.preferences != "" ) {
      text.push("Other preferences: " + subscription.preferences );
    }
    text.push("");
    if( subscription.new ) {
      if ( subscription.voucher != "" ) text.push("Promotion Code: " + subscription.voucher );
      if ( subscription.payment_method != "" ) text.push("Payment Method: " + subscription.payment_method );
      if ( subscription.address != "" ) text.push("Address: " + subscription.address );
      if ( subscription.postcode != "" ) text.push("Postcode: " + subscription.postcode );
      text.push("Country: " + subscription.country );
    }

    return text.join("\n");
  };

  function formSubmit( event ) {
    var fn = MOD + "formSubmit() "
    log( fn + "... ");

    if (typeof event !== 'undefined') event.preventDefault();
    var changes = [];

    /* get some values from elements on the page: */
	//         url = form.attr( 'action' ),

    var form = $( this ),
        sub_element_id = "#" + form.parent().attr("id"),
        sub_id = sub_element_id.replace("#sub-",""),
        current_sub = CURRENT_SUBSCRIPTIONS[sub_id],
        target_sub = {},
        target_sub_text="";
    
    target_sub.payment_method = $( "#payment_method" ).val()
    
    //log( fn + "Current Location: " + LOCATION_PREF.current );

    //log( fn + "Payment: " + target_sub.payment_method );

    //log( fn + "sub_element_id: " + sub_element_id );
    target_sub.new = current_sub.new;
    var new_subscription = target_sub.new;

    
    //log( fn + "sub_id: " + sub_id + ", New sub: " + new_subscription );
    // Get target subscription values
    target_sub.customer_name = getControlValue( sub_element_id, ELEMENT.customer );
    target_sub.customer_email = getControlValue( sub_element_id, ELEMENT.email );
    target_sub.subscription_type = "coffee_delivery";
    target_sub.roasted = getControlValue( ELEMENT.roasted + sub_id );
    target_sub.price = jQuery( ELEMENT.price + sub_id ).text();
    target_sub.quantity = 	getControlValue( ELEMENT.quantity + sub_id );
    target_sub.frequency = 	getControlValue( ELEMENT.frequency + sub_id );
    target_sub.status = 	getControlValue( ELEMENT.status + sub_id );
    target_sub.ground = 	getControlValue( ELEMENT.ground + sub_id );
    target_sub.method = 	getControlValue( ELEMENT.method + sub_id );
    target_sub.milk = 		getControlValue( ELEMENT.milk + sub_id );
    target_sub.preferences = getControlValue( ELEMENT.preferences + sub_id );
    target_sub.voucher = 	getControlValue( ELEMENT.voucher + sub_id );
    target_sub.address = 	getControlValue( ELEMENT.address + sub_id );
    target_sub.postcode = 	getControlValue( ELEMENT.postcode + sub_id );
    target_sub.country = 	$( ELEMENT.country + sub_id ).text();
	// Gift values
    target_sub.gift = 				IS_GIFT;
    target_sub.recipient_name = 	getControlValue( ELEMENT.recipient_name + sub_id );
    target_sub.recipient_email = 	getControlValue( ELEMENT.recipient_email + sub_id );
    target_sub.recipient_address = 	getControlValue( ELEMENT.recipient_address + sub_id );
    target_sub.recipient_postcode = getControlValue( ELEMENT.recipient_postcode + sub_id );
    target_sub.gift_cert_posted = 	getControlValue( ELEMENT.gift_cert_posted + sub_id );
    target_sub.gift_cert_emailed = 	getControlValue( ELEMENT.gift_cert_emailed + sub_id );
    target_sub.recipient_message = 	getControlValue( ELEMENT.recipient_message + sub_id );
    target_sub.recipient_country = 	$( ELEMENT.recipient_country + sub_id ).text();
    
    log( fn + "Target sub: " + JSON.stringify( target_sub ) );

    //
    //	If Subscription type has changed - push change
    //	If Target subscription is 'coffee_delivery' include target quantity
    //
    if ( current_sub.subscription_type != target_sub.subscription_type ) {
      changes.push("Type: " + current_sub.subscription_type + " => <strong>" + target_sub.subscription_type + "</strong>" );
      if ( target_sub.subscription_type == "coffee_delivery" ) {
        changes.push("Quantity: " + target_sub.quantity);
      }
    }
    //
    //	If current and target is 'coffee_delivery' then push Quantity if changed
    //
    if ( current_sub.subscription_type == "coffee_delivery" && target_sub.subscription_type == "coffee_delivery" ) {
      if ( current_sub.quantity != target_sub.quantity ) {
        changes.push("Quantity: " + current_sub.quantity + " => <strong>" + target_sub.quantity + "</strong>");
        changes.push("Price: " + current_sub.price + " => <strong>" + target_sub.price + "</strong>" );
      }
    }

    if ( current_sub.frequency != target_sub.frequency ) {
      changes.push("Frequency: " + current_sub.frequency + " => <strong>" + target_sub.frequency + "</strong>" );
    }

    if ( current_sub.roasted != target_sub.roasted ) {
      changes.push("Roasted or Green: " + current_sub.roasted + " => <strong>" + target_sub.roasted + "</strong>" );
    }

    //	Push changes of Ground, Method, Milk if ROASTED coffee
    if ( current_sub.roasted == "roasted" ) {
      if ( current_sub.ground != target_sub.ground ) {
        changes.push("Ground: " + current_sub.ground + " => <strong>" + target_sub.ground + "</strong>" );
      }
      if ( current_sub.method != target_sub.method ) {
        changes.push("Method: " + current_sub.method + " => <strong>" + target_sub.method + "</strong>" );
      }
      if ( current_sub.milk != target_sub.milk ) {
        changes.push("Black/With Milk: " + current_sub.milk + " => <strong>" + target_sub.milk + "</strong>" );
      }
    }

    if ( current_sub.preferences != target_sub.preferences ) {
      changes.push("Preferences: " + current_sub.preferences + " => <strong>" + target_sub.preferences + "</strong>" );
    }
    if ( new_subscription ) {
      if ( current_sub.voucher != target_sub.voucher ) changes.push("Promotion code: " + current_sub.voucher + " => <strong>" + target_sub.voucher + "</strong>" );
    }
    
    if ( current_sub.status != target_sub.status ) {
      changes.push("Status: " + current_sub.status + " => <strong>" + target_sub.status + "</strong>" );
    }

    //log("Changes: " + changes.join('\n'));

    if ( changes.length == 0 ) {
      //formError("No changes made");
      //return false;
    }
    
    if ( new_subscription ) {
      if ( isBlank( target_sub.customer_name ) ) {
        formError( sub_id, "Oops - you need to enter your name.");
        return false;
      }
      if ( true ) {
        if ( isBlank( target_sub.customer_email ) ||
            target_sub.customer_email.indexOf('@') == -1 ||
            target_sub.customer_email.indexOf(' ') != -1 ) {
          formError( sub_id, "Oops - you need to enter a valid email address");
          return false;
        }
      }
      
      if (true ) {
        if ( IS_GIFT ) {
          if ( isBlank( target_sub.recipient_address ) ) {
            formError( sub_id, "Please enter " + RECIPIENT_FIRSTNAME + "'s delivery address");
            return false;
          }
          if ( isBlank( target_sub.recipient_postcode ) ) {
            formError( sub_id, "Please enter " + RECIPIENT_FIRSTNAME + "'s delivery postcode");
            return false;
          }
        } else {
          if ( isBlank( target_sub.method ) ) {
            formError( sub_id, "Please select your MAIN equipment for making coffee<br/>(not 'All methods')");
            return false;
          }
          if ( isBlank( target_sub.address ) ) {
            formError( sub_id, "Please enter your address");
            return false;
          }
          if ( isBlank( target_sub.postcode ) ) {
            formError( sub_id, "Please enter your postcode");
            return false;
          }
        }
      }
      
    }
    formErrorClose( sub_id );
   //var response = confirm("Your new subscription will be as follows - Is this OK?\n\n" +
                           //toText( target_sub ) + "\n" );
    if( true ) {
      if( IS_GIFT ) {
        $( ELEMENT.message + sub_id ).val(
          "** NEW GIFT SUBSCRIPTION **\n" +
          toText( target_sub ) + "\n"
        );
      } else if ( new_subscription ) {
        $( ELEMENT.message + sub_id ).val(
          "** NEW SUBSCRIPTION **\n" +
          toText( target_sub ) + "\n"
        );
      } else {
        $( ELEMENT.message + sub_id ).val(
          "** SUBSCRIPTION CHANGE REQUEST **\n\n" +
          "<a href='http://localhost:3000/subscriptions/" + current_sub.id + "' target=_blank >" +
          current_sub.name + "</a>\n\n" +
          "START ================" + "\n" +
          changes.join( "\n" ) + "\n" +
          "END ================" + "\n\n" +
          "NEW Subscription" + "\n" +
          "================" + "\n" +
          toText( target_sub ) + "\n"
        );
      }
      //log("Message: " + message);
      $( ELEMENT.message ).html( "<h3>Sending...</h3>"  );
      $( ELEMENT.message ).show();
      
      var action  = '/contact?';
    	action += encodeURIComponent('form_type') +'='+ encodeURIComponent('contact');
    	action += '&' + encodeURIComponent('utf8') +'='+ encodeURIComponent('✓');

      //info("Posting form. ID: " + sub_id + " Action: " + action + " messageElement: " + ELEMENT.message + sub_id);
      if( new_subscription ) {
        message( "Going to Payment Setup..." );
      } else {
        message( "Saving subscription preferences..." );
      }
 
      var posting = $.post( action, $(this).serialize() );

      posting.done(function( data ) {
        log(fn + "Posting complete" );
        //log( fn + data );
        
        var hero_elements = $( data ).find( ".hero" ); 
        var success_elements = $( data ).find( "#form-success" );
        var error_elements = $( data ).find( "#form-errors" );
        var challenge_step = false;

        if ( data.toLowerCase().includes("challenge step") || hero_elements[0] ) {
          	challenge_step = true;
        }
        
        log( fn + "success_elements: " + success_elements.length );
        log( fn + "error_elements: " + error_elements.length );
        log( fn + "hero_elements: " + hero_elements.length );

        if ( challenge_step ) {	
          log( fn + "Challenge message..." );
          $( ELEMENT.error + sub_id ).html( "<h1 class='center'>Please complete the following challenge</h1>" + data );
          $( ELEMENT.hide_on_challenge ).hide();
          $( ELEMENT.error + sub_id ).show();
          
        } else if ( error_elements[0] )  {
          log( fn + "Error message: " + error_elements[0] );
          $( ELEMENT.error + sub_id ).html(error_elements[0].innerHTML);
          $( ELEMENT.error + sub_id ).show();
          //warning(fn + "Error submitting Subscription Change Request");
          //console.error(" submitting Subscription Change Request");
          
        } else { // Assume success
          log( fn + "Success message: " +  success_elements[0] );
          
          $( ELEMENT.success + sub_id ).show();
          $( ELEMENT.change_form + sub_id ).hide();

          if( sub_id == "ID-0" ) {
            if( target_sub.payment_method == "credit_card" ) {
              log( fn + "Going to Credit Card signup..." );
              window.location.href = CREDIT_CARD_SIGNUP;
              //window.open( CREDIT_CARD_SIGNUP );
            } else if ( target_sub.payment_method == "direct_debit" ) {
              log( fn + "Going to Direct Debit signup..." );
              window.location.href = GOCARDLESS;
              //window.open( GOCARDLESS );
            } else if ( target_sub.payment_method == "pay_upfront" ) {
              log( fn + "Going to One-Off Payment..." );
              window.location.href = PAY_UPFRONT;
              //window.open( PAY_UPFRONT );
            } else {
              log( fn + "Going to Payment Setup..." );
              window.location.href = PAYMENT_SETUP;
            }
          }

          //window.location = ELEMENT.success + sub_id;		// Not used
          closeMessage();
          tcrTrack( "Submitted Subscription Change",
                   { title: current_sub.name }
                  );

          log(fn + "Subscription Change Request submitted OK");
          
        }});
    }
    log( fn + "...OK" );
  };
    
   //else { //	Could not find Success or Error messages - something went wrong.
          // Assume OK and continue - NEEDS FIXING.
          //log( fn + data );
         // error( fn + "NO Captcha. Success or Error messages found" );

          //$( ELEMENT.error + sub_id ).html( "<h3>Sorry, something went wrong. Please try again</h3>"  );
          //window.location.href = "#sub-error-" + sub_id
          //$( ELEMENT.error + sub_id ).html( data );
          //$( ELEMENT.error + sub_id ).show();
        //}

      //}
    

 // Initialise any subscription offers. Get from session storage, set promo code field and display
 function initSubscriptionOffer() {
    var offer = getOffer();
   
    if( notBlank( offer ) && notBlank( offer.subOffer ) ) {
      
      offerChange( "" , offer.refCode ) ;
      displaySubscriptionOffer( offer );
    } else {
       clearSubscriptionOffer();
    }
  };
    
  
  //	 Refresh the subscription form with latest values
  function refreshForm( sub_id ) {
    var fn = MOD + "refreshForm():" + sub_id + " ";
    var country, country_zone;
    
    //log( fn + "Country: " + $( ELEMENT.country + sub_id).text() );

    formErrorClose( sub_id );
    country = $( ELEMENT.country + sub_id).text();
    if ( isBlank(country) ) {
      log( fn + "Location not ready" );
      return;
    }
    if ( ! SUB_FORM_READY ) {
      log( fn + "Sub Form not ready" );
      return;
    }
    //$( ELEMENT.voucher_message + sub_id ).html( VOUCHER_MESSAGE );
    
    country_zone = getCountryZone( country );
    
    //log( fn + "Country: " + country + ", Zone: " + country_zone );
    
    if( country_zone == "United Kingdom" ) {
      $( ".submit_direct_debit" ).show();
      $( ".submit_credit_card" ).show();
      $( ".submit_pay_upfront" ).show();
      $( ELEMENT.delivery_location_message ).html( "" );

    } else if( country_zone == "Europe" ) {
      $( ".submit_direct_debit" ).hide();
      $( ".submit_credit_card" ).show();
      $( ".submit_pay_upfront" ).show();
      $( ELEMENT.delivery_location_message ).html( "" );

    } else {
      $( ".submit_direct_debit" ).hide();
      $( ".submit_credit_card" ).hide();
      $( ".submit_pay_upfront" ).hide();
      
      $( ELEMENT.delivery_location_message ).html(
          "To get more info about delivery to " + country
      );

      if( sub_id != "ID-0" ) {	// Existing subs
        $( ELEMENT.delivery_location_message ).append(
        	"<p>(This is the country of your default address in your account)</p>"
        );
      }
      
      $( ELEMENT.form_id + sub_id ).hide();
    return;
    }

    var price;
	var price_in_pence;
    var qty_in_grams;
    var roasted = getControlValue( ELEMENT.roasted + sub_id );
    var quantity = getControlValue( ELEMENT.quantity + sub_id );

    //	Set Subscription PRICE, GROUND, METHOD & MILK based on ROASTED or GREEN
    if( roasted == "roasted" ) {
      jQuery( ELEMENT.roasted_only + sub_id ).show();
      price = PRICES.roasted[ country_zone ][ quantity ];
    } else {		// GREEN
      jQuery( ELEMENT.roasted_only + sub_id ).hide();
      price = PRICES.green[ country_zone ][ quantity ];
    }
    
    if( isBlank( price ) ) {
    	price = "99.99";
    }

    //	Set the new price
    price_in_pence = parseFloat(price) * 100;

    if ( quantity == "2 x 250g" ) {
      qty_in_grams = 500;
    } else {
      qty_in_grams = parseInt(quantity);
    }

    $( ELEMENT.price + sub_id ).html( "£" + price +
                                          " including delivery" );
    
    // Set Name and Gift values
    if( IS_GIFT ) {
    	$( ELEMENT.gift + sub_id ).text( "Yes" );
    	$( ELEMENT.firstname + sub_id ).text( RECIPIENT_FIRSTNAME + "'s" );
    	$( ELEMENT.determiner + sub_id ).text( "their" );
    	$( ELEMENT.do_does + sub_id ).text( "does " + RECIPIENT_FIRSTNAME );
      	$( ELEMENT.tbd_text + sub_id ).text("If you don't know all the details - they can easily be changed later.");

      	$( ELEMENT.recipient_address_form + sub_id ).show();
      	$( ELEMENT.my_address_header + sub_id ).text("4 - Your name and email");
      	$( ELEMENT.my_address_form + sub_id ).hide();
    } else {
    	$( ELEMENT.gift + sub_id ).text( "No" );
      	$( ELEMENT.firstname + sub_id ).text( "my" );
    	$( ELEMENT.determiner + sub_id ).text( "your" );
    	$( ELEMENT.do_does + sub_id ).text( "do you" );
      	$( ELEMENT.recipient_address_form + sub_id ).hide();
      	$( ELEMENT.my_address_header + sub_id ).text("3 - Your name, email and delivery address");
      	$( ELEMENT.my_address_form + sub_id ).show();
    }
    
    
    //log( fn + "Roasted: " + roasted);
    //log( fn + "Quantity: " + qty_in_grams + "g" );
    //log( fn + "Price: " + price);
    
    //	All OK - show the form
    $( ELEMENT.form_id + sub_id ).show();
    log( fn + "...OK" );
  };
  
  //	Change function for Delivery Location. This should only be called when site location changes
  function deliveryLocationChange( event, country ) {
    var fn = MOD + "EVENT: Site Location CHANGE: ";


    //LOCATION_READY = true;
    //log( fn + COUNTRY + ":" + COUNTRY_ZONE );
    //log( fn + country );

    var sub_id = "ID-0";		// Only updates New Subscription 
    $( ELEMENT.country + sub_id ).text( country );
    //log( fn + "Updated site country to: " + $( ELEMENT.country + sub_id ).text() );
    refreshForm( sub_id );
  };
  
  //	Change function for Method
  function methodChange( event, method ) {
    var fn = MOD + "EVENT: Method CHANGE: ";

    var sub_id = "ID-0";
    $( ELEMENT.method + sub_id + " select").val( method.toLowerCase() )
    refreshForm( sub_id );
  };
  
  //	Change function for Ground
  function grindChange( event, ground ) {
    var fn = MOD + "EVENT: Ground CHANGE: ";

    var sub_id = "ID-0";
    if( ground == "Ground" ) {
    	$( ELEMENT.ground + sub_id + " select").val( "yes")
    } else {
    	$( ELEMENT.ground + sub_id + " select").val( "no")
    }
      
    refreshForm( sub_id );
  };
  
  //	Change function for Offer/Referral
  function offerChange( event, code ) {
    var fn = MOD + "EVENT: Offer CHANGE: ";

    var sub_id = "ID-0";
    
    $( ELEMENT.voucher + sub_id + " input").val( code )
    refreshForm( sub_id );
  };


  
  //	Change function for Milk
  function milkChange( event, milk ) {
    var fn = MOD + "EVENT: Milk CHANGE: ";

    var sub_id = "ID-0";
    var milk_option = "black";
    
    switch ( milk ) {
      case "With milk":
        milk_option = "with_milk";
        break;
      case "Milky":
        milk_option = "milky";
        break;
    }
    
    $( ELEMENT.milk + sub_id + " select").val( milk_option )
    refreshForm( sub_id );
  };
  
  // VOUCHER Change function
  function voucherChanged( element, sub_id ) {
    var fn = MOD + "EVENT: Voucher CHANGE: ";
    var voucher = $(element).children("input").val();
    var voucher = voucher.toLowerCase();

    log( fn + sub_id + ":Now " + voucher );
    setReferralOffers( voucher );
    initSubscriptionOffer();
  };

  // RECIPIENT NAME Change function
  function recipientNameChanged( element, sub_id ) {
    var fn = MOD + "recipientNameChanged() "
    var recipient_name = $(element).children("input").val().trim();

    var name_1 = getToken( recipient_name, 1, " " );
    var name_2 = getToken( recipient_name, 2, " " );
    var name_3 = getToken( recipient_name, 3, " " );

    log( fn + "recipient_name: " + recipient_name);
    //log( fn + "name_1: " + name_1 + ", name_2: " + name_2 + ", name_3: " + name_3);

    if( isBlank( name_3 ) ) {		// Name has 2 words
      RECIPIENT_FIRSTNAME = name_1;
      RECIPIENT_LASTNAME = name_2;
    } else {
      RECIPIENT_FIRSTNAME = name_1 + " " + name_2;
      RECIPIENT_LASTNAME = name_3;
    }
    
    //	Recipients name has been entered/changed so show the main form
    if ( notBlank( RECIPIENT_FIRSTNAME ) ) {
      refreshForm( sub_id );
      $( "#sub-" + sub_id ).show();
    } else {
      $( "#sub-" + sub_id ).hide();
    }
 
  };


  function initFormFields() {
    var fn = MOD + "initFormFields() "
    log( fn + "...");

    // Initialise Form SUBMIT function
    $( ELEMENT.form ).submit( formSubmit );
    
    //	Prevent Enter key submitting form
    $( ELEMENT.form ).on('keyup keypress', function(e) {
      var code = e.keyCode || e.which;
      if (code == 13) { 
        e.preventDefault();
        return false;
      }
    });

    jQuery.each( CURRENT_SUBSCRIPTIONS, function(sub_id, subscription) {
      //	Set any default values not set in Subscription JSON from TCR Portal
      //log( fn + sub_id + " Roasted: " + subscription.roasted );
      if ((typeof subscription.roasted) == "undefined") {
        subscription.roasted = "roasted"
      }
      if ((typeof subscription.voucher) == "undefined") {
        subscription.voucher = ""
      }

      log( fn + sub_id + ": Creating input elements...");

      //	Create Subscription elements TYPE, ROASTED, GROUND, METHOD, MILK
      //jQuery( ELEMENT.type + sub_id ).html( newSelectElement(
      //  OPTIONS.type, subscription.subscription_type ));
      
      jQuery( ELEMENT.roasted + sub_id ).html( newSelectElement(
        OPTIONS.roasted, subscription.roasted ));
      
      jQuery( ELEMENT.ground + sub_id ).html( newSelectElement(
        OPTIONS.ground, subscription.ground ));
      jQuery( ELEMENT.method + sub_id ).html( newSelectElement(
        OPTIONS.method, subscription.method ));
      jQuery( ELEMENT.milk + sub_id ).html( newSelectElement(
        OPTIONS.milk, subscription.milk ));
      
      jQuery( ELEMENT.quantity + sub_id ).html( newSelectElement(
        OPTIONS.quantity, subscription.quantity ));

      //	Subscription FREQUENCY
      jQuery( ELEMENT.frequency + sub_id ).html( newSelectElement(
        OPTIONS.frequency, subscription.frequency ));

      //	Subscription STATUS
      jQuery( ELEMENT.status + sub_id ).html( newSelectElement(
        OPTIONS.status, subscription.status ));

      //	Subscription PREFERENCES
      jQuery( ELEMENT.preferences + sub_id ).html( "<textarea rows='3' name='preferences'>" + 
                                                 subscription.preferences +
                                                 "</textarea>" );

      //	Subscription Voucher
      jQuery( ELEMENT.voucher + sub_id ).html( "<input type='text' name='voucher'>" + 
                                             subscription.voucher +
                                             "</input>" );
     	//	Subscription ADDRESS
      jQuery( ELEMENT.address + sub_id ).html( "<textarea rows='3' name='address'>" + 
                                                 subscription.address +
                                                 "</textarea>" );

      //	Subscription POSTCODE
      jQuery( ELEMENT.postcode + sub_id ).html( "<input type='text' size='10' name='postcode'>" + 
                                             subscription.postcode +
                                             "</input>" );
      
      //	Gift Name at the top
      jQuery( ELEMENT.gift_name ).html( "<input type='text' name='gift_name'>" + "</input>" );
      
      //	Gift Name in the subscription
      jQuery( ELEMENT.recipient_name + sub_id ).html(
        "<input type='text' name='recipient_name'>" +
        subscription.recipient_name + "</input>" );
      
      //	Gift Recipient Email
      jQuery( ELEMENT.recipient_email + sub_id ).html( 
        "<input type='text' name='recipient_email' placeholder='Recipients Email'>" + 
        subscription.recipient_email + "</input>" );

      //	Gift Recipient ADDRESS
      jQuery( ELEMENT.recipient_address + sub_id ).html(
        "<textarea rows='3' name='recipient_address' placeholder='Recipients Address' >" +
        subscription.recipient_address + "</textarea>" );

      //	Gift Recipient POSTCODE
      jQuery( ELEMENT.recipient_postcode + sub_id ).html(
        "<input type='text' size='10' name='recipient_postcode' placeholder='Recipients Postcode'>" + 
        subscription.recipient_postcode + "</input>" );
      
      //	Personal Message to recipient
      jQuery( ELEMENT.recipient_message + sub_id ).html(
        "<textarea rows='3' name='recipient_message'>" + 
        subscription.recipient_message + "</textarea>" );
      
      log( fn + sub_id + ": Creating input elements...OK");
      
      // Bind Change functions...
      log( fn + sub_id + ": Binding Change functions...");

      //	ROASTED or GREEN change function
      jQuery( ELEMENT.roasted + sub_id ).change( function() {
        //log( fn + sub_id + ":Roasted changed to " + $(this).children().first().val() );
		refreshForm( sub_id );
      });
      //	QUANTITY change function
      jQuery( ELEMENT.quantity + sub_id ).change( function() {
        //log( fn + sub_id + ":Quantity changed to " + $(this).children().first().val() );
		refreshForm( sub_id );
      });
      //	PROMO-CODE/VOUCHER change function
      jQuery( ELEMENT.voucher + sub_id ).change( function() {
		voucherChanged( $(this), sub_id )
        refreshForm( sub_id );
      });

      //	Click functions for GIFT buttons.
      //	Note: Yes/No buttons are not specific to a subscription
      jQuery( ELEMENT.gift_no ).click( function() {
        log( fn + sub_id + ":Gift is NO" );

        IS_GIFT = false;
        $( ELEMENT.gift_name_prompt ).hide();
        
        refreshForm( sub_id );
        $( "#sub-" + sub_id ).show();
      });

      jQuery( ELEMENT.gift_yes ).click( function() {
        log( fn + sub_id + ":Gift is YES" );

        IS_GIFT = true;
        $( ELEMENT.gift_name_prompt ).show();
        if ( isBlank( RECIPIENT_FIRSTNAME ) ) {
          $( "#sub-" + sub_id ).hide();
        }

      });
      
      //	GIFT NAME change function (at top of form)
      jQuery( ELEMENT.gift_name ).change( function() {
        var gift_name = $(this).children("input").val().trim();

        //log( fn + sub_id + ":Gift Name changed to " + gift_name );

        // Gift Name (at top) has changed so update Recipient Name
        jQuery( ELEMENT.recipient_name + sub_id ).children("input").val( gift_name );
        recipientNameChanged( $(this), sub_id )
        refreshForm( sub_id );
      });

      //	RECIPIENT's NAME change function (in sub)
      jQuery( ELEMENT.recipient_name + sub_id ).change( function() {
        //log( fn + sub_id + ":Recipient Name changed to " + $(this).children("input").val() );
        recipientNameChanged( $(this), sub_id )
        refreshForm( sub_id );
      });

      

      log( fn + sub_id + ": Binding Change functions...OK");
      
      if ( sub_id != "ID-0" ) { // Existing subscription
        var default_country = $(ELEMENT.country + sub_id).text();
        //log( fn + sub_id + ":Delivery Country: " + default_country );
      }
      
      SUB_FORM_READY = true;
      refreshForm( sub_id );

    });
    
    log( fn + ": Binding Other elements...OK");

    // All Document fields are now set up

    log( fn + '...OK');

  };
  
  
  
  $(document).ready(function() {
    var fn = MOD + "doc() ";
    log( fn + "DOM ready" );
    initFormFields();
    initSubscriptionOffer();   
  });


  function main(){
    var fn = MOD + "main() "
    log( fn + "...");
    
    //	Set the Change function for Delivery Location
    $( "body" ).on( LOCATION_PREF.change_event, deliveryLocationChange );
    $( "body" ).on( METHOD_PREF.change_event, methodChange );
    $( "body" ).on( GRIND_PREF.change_event, grindChange );
    $( "body" ).on( MILK_PREF.change_event, milkChange );
    
    // Call events if values are already available
    if ( notBlank( LOCATION_PREF.current ) ) 	deliveryLocationChange( "" , LOCATION_PREF.current )
    if ( notBlank( METHOD_PREF.current ) ) 		methodChange( "" , METHOD_PREF.current )
    if ( notBlank( GRIND_PREF.current ) )		grindChange( "" , GRIND_PREF.current )
    if ( notBlank( MILK_PREF.current ) )		milkChange( "" , MILK_PREF.current )

    //jQuery.each(CURRENT_SUBSCRIPTIONS, function(key, subscription) {
    //  log("Subscription: " + key + ", " + subscription.name)
    //});
    

    log( fn + "...OK");

  };

  main();

  log( MOD + "JS...OK")

  //	Public methods and variables
  return {
    push: pushSubscription,
    initFormFields: initFormFields
  };


})();	// End of TCR.subscription Module - IFFE pattern